export default "__VITE_ASSET__ee016a67__"